// extracted by mini-css-extract-plugin
module.exports = {"transaction":"styles_transaction__mopTk","amount":"styles_amount__19gQ2","filter":"styles_filter__1v0M-","search":"styles_search__1A6uk"};